import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { animateScroll as scroll } from "react-scroll";
import ROUTE from "../../constants/route";
import Layout from "../../components/layout/Layout";
import FilteredGraph from "./FilteredGraphPanel";
import { MockupWarning } from "../../util/dev_layout";
import ComparePanel from "./ComparePanel";
import { CompareRow, GraphProvider } from "../../components/report/GenericGraphDrawer";
import { TargetValueType } from "./CompareValuePanel";
import { isFillAlive, isFunction, isAlive, RouteUtil } from "../../util";
import { ContainerLoading, PreloadDiv } from "../../components/loading/PersistGateLoading";
import { Metrics } from "../../theme";
import { LimitDataBox } from "../../components/report/ErrorGraphBox";
import UpgradePlanWarning from "../UpgradePlanWarning";

class ReportGenericIndividual extends React.Component{
    comparePanel = null;
    filterGraph = React.createRef();
    state={
    	main:{
    		loading:false,
    		select:undefined,
    		[TargetValueType.Primary]:undefined,
    		[TargetValueType.Secondary]:undefined
    	},
    }
	
    componentDidMount(){
    		this.requeryMain(true);
    }
    requeryMain(autoSelect = false){
    	const { getAutoSelectItem, mainSelectToFilterValue, typeKey } = this.props;
    	const { primary, secondary } = this.comparePanel.getDateRanges();
    	const { main } = this.state;
    	main.loading = true;
    	main[TargetValueType.Primary] = undefined;
    	main[TargetValueType.Secondary] = undefined;
    	this.setState({main},()=>{
    		const types = [TargetValueType.Primary];
    		if(isFillAlive(secondary)){
    			types.push(TargetValueType.Secondary);
    		}
    		let remain = types.length;
    		types.forEach(t=>{
    			this.handleMainFetch(
    				this.internalFetchMain(t), t, (res)=>{
    					remain -= 1;
    					if(isFillAlive(res)){
    						if(t === TargetValueType.Primary && autoSelect && isFunction(getAutoSelectItem)){
    							const { location: { state } } = this.props;
    							main.select = state || getAutoSelectItem(res);
    							if(isFunction(mainSelectToFilterValue)){
    								main.select = mainSelectToFilterValue(typeKey, main.select);
    							}
    							if(main.select!==undefined && remain === 0){
    								this.forceUpdate();
    							}
    						}
    					}
    				}
    			);
    		});
    	});
    }
    handleMainFetch(promise, type, onFetched, onError){
    	const { header, subHeader, mainReadKey } = this.props;
    	let { main } = this.state;
    	promise.then(res=>{
    		const resStateMain = this.state.main;
    		resStateMain.loading = false;
    		resStateMain[type] = res[mainReadKey];
    		this.setState({main:resStateMain},
    			onFetched ? ()=>{onFetched(res[mainReadKey]);} : undefined);
    	}).catch(error=>{
    		const resStateMain = this.state.main;
    		resStateMain.loading = false;
    		console.error(`fetchReport[${header} : ${subHeader}].updateMain.error: `,error);
    		this.setState({main:resStateMain},onError);
    	});
    }
	internalFetchDeep = (type, filters)=>{
		const { fetchDeep } = this.props;
		const dateRange = this.comparePanel.getDateRange(type);
		return fetchDeep({type, filters, dateRange, errorOnInfo:false});
	}
	internalFetchIndividual = (type, filters)=>{
		const { fetchIndividual } = this.props;
		const dateRange = this.comparePanel.getDateRange(type);
		return fetchIndividual({type, filters, dateRange, errorOnInfo:false});
	}
    internalFetchMain = (type, filters)=>{
    	const { fetchMain } = this.props;
    	const dateRange = this.comparePanel.getDateRange(type);
    	return fetchMain({filters, dateRange});
    }
	internalSearchEmployee = (type, filters, option)=>{
		const { searchEmployee } = this.props;
		const dateRange = this.comparePanel.getDateRange(type);
		return searchEmployee({dateRange, filters, option});
	}
	internalGetExportPromise = (primary, secondary)=>{
		const { getExportPromise } = this.props;
		const filters = this.filterGraph.current ? 
			this.filterGraph.current.getFilterForRequest() : undefined;
		return getExportPromise({dateRange:{primary,secondary}, filters});
	}
    onMainClick = (mainItem, errorOnInfo, loadingFirst = true)=>{
    	const { 
    		typeKey, itemToSelectValue, filterToRequest, onFetched,
    		mainSelectToFilterValue
    	} = this.props;
    	const { main } = this.state;
    	main.select = mainSelectToFilterValue ? 
    		mainSelectToFilterValue(typeKey, mainItem)
    		: filterToRequest(typeKey, mainItem).value; 
    	this.setState({main},()=>{
    		if(isAlive(this.filterGraph.current)){
    			this.scrollTo(this.filterGraph.current.getOffsetOf(typeKey));
    		}
    	});
    }
    onDateChanged = (date)=>{
    	this.requeryMain();
    }
	onIndividualClick = (record)=>{
		const { history } = this.props;
		history.push(`/${ROUTE.INDIVIDUAL_USER}/${record.id}`);
	}
	scrollTo = (yOffset)=>{
		scroll.scrollTo(yOffset-113, {
			duration:600,
			containerId:"scroll-container"
		});
	}
	render(){
		const { header, subHeader, typeKey, drawSingleGraph, 
			drawListGraph, calculateDeepMax, 
			filterToRequest, filterToBread, 
			getExportPromise, beforeCompareComp,
			mockupMessage
		} = this.props;
		const { main, } = this.state;
	 const canEnterThisRoute= RouteUtil.CheckRoutePermission(); 
		return <React.Fragment>
			{mockupMessage ? <MockupWarning message={mockupMessage} /> : undefined}
			<Layout id="scroll-container">
				{beforeCompareComp}
				<ComparePanel
					setRef={(ref)=>{
						this.comparePanel=ref;
					}}
					header={header}
					subHeader={subHeader}
					onPrimaryDateChanged={this.onDateChanged}
					onSecondaryDateChanged={this.onDateChanged}
					getExportPromise={getExportPromise ? 
						this.internalGetExportPromise : undefined}
					disableExport = {!isAlive(main.select)}
					showHeaderOptionBar={canEnterThisRoute}
					showSecondaryDatePicker>
					{({showCompare, dateRange})=>(
						<React.Fragment>
							{canEnterThisRoute?
								<ContainerLoading isLoading={main.loading} loadingChildren={<PreloadDiv />}>
									<CompareRow 
										style={{paddingTop:Metrics.button.bigSpaceMargin}}
										primary={main[TargetValueType.Primary] ? 
											<DrawSingleGraph 
												drawer={drawSingleGraph} 
												single={!showCompare}
												header={subHeader} 
												typeKey={typeKey}
												type={TargetValueType.Primary}
												summary={main[TargetValueType.Primary]}
												hilight={main.select}
												onMainClick={this.onMainClick}
											/>
											: <LimitDataBox />} 
										secondary={main[TargetValueType.Secondary] ? 
											<DrawSingleGraph 
												drawer={drawSingleGraph} 
												single={!showCompare}
												header={subHeader} 
												typeKey={typeKey}
												type={TargetValueType.Secondary}
												summary={main[TargetValueType.Secondary]}
												previousSummary={main[TargetValueType.Primary]}
												hilight={main.select !== undefined}
												onMainClick={this.onMainClick}
											/> : showCompare ? <LimitDataBox /> : undefined
										} />
									{main.select ?
										<FilteredGraph
											ref={this.filterGraph}
											scrollTo={this.scrollTo}
											initFilter={{key:typeKey, value:main.select}}
											fetchDeep={this.internalFetchDeep}
											fetchIndividual={this.internalFetchIndividual}
											searchEmployee={this.internalSearchEmployee}
											drawList={drawListGraph} 
											dateRange={dateRange}
											showCompare={showCompare}
											exclude={[typeKey]}
											onIndividualClick={this.onIndividualClick}
											calculateDeepMax={calculateDeepMax}
											filterToRequest={filterToRequest}
											filterToBread={filterToBread}
										/> : undefined}
								</ContainerLoading>
								:<UpgradePlanWarning/>
							}
						</React.Fragment>)
					}
				</ComparePanel>
				
			</Layout>
		</React.Fragment>;
	}
}

const DrawSingleGraph = (props)=>{
	const {
		drawer, 
		type, 
		typeKey,
		summary, 
		previousSummary, 
		hilight, 
		single,
		header, 
		onMainClick
	} = props;
	const Drawer = drawer;
	return <GraphProvider 
		isVertical={!single} 
		colorType={type}
		showArrow={hilight} 
		hilight={hilight}
		short={false}>
		<Drawer 
			header={header}
			typeKey={typeKey}
			single={single}
			object={summary}
			previousObject={previousSummary}
			isVertical={hilight}
			colorType={type}
			showLegend={true}
			showValue={true}
			onClick={onMainClick}
			clickHeader={false}
		/>
	</GraphProvider>;
};

const DefaultGraphDrawer = (props)=><div>Draw graph here</div>;

ReportGenericIndividual.defaultProps = {
	drawSingleGraph: DefaultGraphDrawer,
	drawListGraph: DefaultGraphDrawer,
	getAutoSelectItem:(totalResponse)=>{
		const keys = Object.keys(totalResponse);
		if(keys.length > 0){
			return keys[0];
		}
		return null;
	},
	mainReadKey:"total",
};

ReportGenericIndividual.propTypes = {
	header:      PropTypes.string.isRequired,
	subHeader:   PropTypes.string.isRequired,
	typeKey:     PropTypes.string,
	headKeys:    PropTypes.arrayOf(PropTypes.string),
	mainReadKey:          PropTypes.string,
	drawSingleGraph:      PropTypes.func,
	drawListGraph:        PropTypes.func,
	fetchMain:            PropTypes.func.isRequired,
	fetchDeep:            PropTypes.func.isRequired,
	fetchIndividual:      PropTypes.func.isRequired,
	searchEmployee:		  PropTypes.func.isRequired,
	getExportPromise:	  PropTypes.func,
	/**
	 * Get auto select filter by the response
	 */
	getAutoSelectItem:    PropTypes.func,
	/**
	 * Create filter from select value from render graph.
	 */
	mainSelectToFilterValue: PropTypes.func,
	calculateDeepMax:	  PropTypes.func,
	filterToRequest:	  PropTypes.func,
	filterToBread:	      PropTypes.func,
};
export default withRouter(ReportGenericIndividual);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/ReportGenericIndividual.js